import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Survey } from 'survey-react-ui';
import * as SurveyCore from 'survey-core';
import * as ApiService from "../../services/ApiService";
import { ApplicationContext } from '../../ApplicationState';
import { IonContent, IonPage } from '@ionic/react';
import { themeJson } from '../../components/SurveyForms/CreateCustomSurvey';
import { FunctionFactory } from 'survey-core';
var _ = require("lodash");

// import { surveyCss } from 'survey-core';
// import "survey-creator-core/survey-creator-core.css";
// import "survey-core/defaultV2.css";

// Define an interface for the route parameters
interface SurveyParams {
    id: string; // Assuming 'id' is a string
}

const SurveyDisplayComponent = () => {
    const { id } = useParams<SurveyParams>();  // Get surveyId from the URL

    const [surveyJson, setSurveyJson] = useState(null);
    const { userState } = useContext(ApplicationContext)
    const location: any = useLocation();
    const searchparams = new URLSearchParams(location.search).get("access_token")
    const searchparamsusername = new URLSearchParams(location.search).get("username")
    const schIdParam = new URLSearchParams(location.search).get("sch_type")
    const status = new URLSearchParams(location.search).get("status")

    useEffect(() => {
        ApiService.getSurveysByid(searchparams, id, status).then((res) => {
            if (res) {
                const surveyJson = JSON.parse(res.jsonData)

                if (schIdParam === 'fromWeb') {
                    surveyJson.completedHtml = `
                    <h2 style="text-align: center;">Thank you for completing the survey!</h2>
                    <p style="text-align: center;">Now you can close this tab.</p>
                    <div style="display: flex; justify-content: center; margin-top: 20px;">
                         <button type="button" style="padding: 10px 20px; font-size: 16px; cursor: pointer;" onclick="window.close()">Close this tab!</button>
                    </div>`;
                }

                setSurveyJson(surveyJson)
                //const surveyUrl = `${window.location.origin}/survey/${id}`;  // Generate the survey URL
            }
        }).catch(err => {
            alert('Something went wrong. Please try again.')
        })
    }, [id])



    if (!surveyJson) {
        return <IonPage>
            <IonContent style={{ backgroundColor: "white", overflow: "scroll", display: "flex", justifyContent: 'center' }}>
                <div style={{ alignItems: 'center', marginTop: 20, marginLeft: 50 }}> Loading survey... </div>
            </IonContent>
        </IonPage>
    }



    const survey = new SurveyCore.Model(surveyJson)

    // function isNumberValid(number) {
    //     console.log("🚀 ~ isNumberValid ~ number:", number)
    //     console.log("🚀 ~ isNumberValid ~ number:", Number(number))

    //     let res = !isNaN(Number(number));
    //     console.log("🚀 ~ isNumberValid ~ res:", res)

    //     if (res) {
    //         return true
    //     }
    //     return 'Please enter a valid number.'
    // }

    // const surveyCss = {};
    // surveyCss["sv-dropdown"] = {
    //     zIndex: "1000",
    // };
    // surveyCss["sv-boolean"] = {
    //     zIndex: "1",
    // };
    // surveyCss["sv-question"] = {
    //     marginBottom: "20px",
    //     position: "relative",
    // };
    // surveyCss["sv-dropdown__popup"] = {
    //     position: "absolute",
    // };
    // survey.applyTheme(surveyCss);

    survey.applyTheme(themeJson)

    // FunctionFactory.Instance.register("isNumberValid", isNumberValid);

    const transformSurveyData = (surveypages, surveys) => {

        return surveypages.flatMap((page) =>
            page.elements
                .filter((element) => surveys[element.name] !== undefined)
                .map((element) => {

                    let value = surveys[element.name];
                    console.log("🚀 ~ .map ~ value:", element.type, value)


                    if (element.type === "boolean") {
                        value = value === true ? 'true' : 'false'
                    }

                    // Handle radiogroup choices
                    if (element.type === "radiogroup" && typeof value === "string") {
                        const choice = element.choices.find((c) => c.value === value);
                        value = choice?.text || value; // Map value to text if available

                    }

                    if (element.type === "checkbox") {
                        value = _.map(value, v => {
                            const choice = element.choices.find((c) => c.value === v);
                            console.log("🚀 ~ .map ~ choice:", choice?.text)

                            return choice?.text || value; // Map value to text if available
                        })

                    }

                    if (element.type === "dropdown" && typeof value === "string") {
                        const choice = element.choices.find((c) => c.value === value);
                        value = choice?.text || value; // Map value to text if available

                    }

                    return {
                        name: element.name,
                        title: element.title,
                        value,
                        type: element.type,
                        sentiment: ''
                    };
                })

        );
    }

    survey.onComplete.add(function (result) {
        // console.log("🚀 ~survey  result.data :", result.data)
        // console.log("🚀 ~survey  result['jsonObj'] :", result['jsonObj'].pages)


        const resultdata = transformSurveyData(result['jsonObj'].pages, result.data)

        //alert("Survey completed: " + JSON.stringify(result.data));
        const data = {
            surveyData: JSON.stringify(result.data),
            surveyId: id,
            userId: searchparamsusername,
            CompletedOn: new Date(),
            scheduleId: schIdParam,
            SurveyResponses: JSON.stringify(resultdata),
        }

        ApiService.createSurveyResults(searchparams, data).then(res => {
            if (res) {
                ApiService.surveyResponseSentimentAnalyze(searchparams, res.data).then(res => {
                    console.log('sucess')
                })
            }
        }).catch(err => {
            console.log("🚀 ~ ApiService.updateSurvey ~ error : ")
        })


    })

    return (
        <IonPage>
            <IonContent style={{ backgroundColor: "white", overflow: "scroll", display: "flex" }}>
                <Survey model={survey} />
            </IonContent>
        </IonPage>

    )
}

export default SurveyDisplayComponent;